{
  "generic": "Beklenmeyen bir hata oluştu",
  "network": "Ağ hatası. Bağlantınızı kontrol edin.",
  "notFound": "Sayfa bulunamadı",
  "forbidden": "Erişim reddedildi",
  "tryAgain": "Tekrar dene"
}
